import get from 'lodash/get'
import { stringLength, required } from '../../utils/validations'
import { PepOptions } from '../../constants'

export const isPep = (values: any) => get(values, 'pep') === PepOptions.Yes

const validate = (values: any) => ({
  education: required(get(values, 'education')),
  stayOnAddressDuration: required(get(values, 'stayOnAddressDuration')),
  livingType: required(get(values, 'livingType')),
  otherDocumentType: required(get(values, 'otherDocumentType')),
  pep: required(get(values, 'pep')),
  pepReason: isPep(values)
    ? required(get(values, 'pepReason')) || stringLength(3, 200)(get(values, 'pepReason'))
    : undefined,
})

export default validate
